import { MenuItem, Box, SelectChangeEvent } from "@mui/material";
import useIsMobile from "../hooks/useIsMobile";
import { TimezoneAbbreviations, Timezones } from "./Timezones";
import Select from "./Select";

export default ({
  timezone,
  setTimezone,
  sx,
  placeholder = "Select timezone",
  isSelectionClearable = false,
  size = "medium",
}: {
  timezone: string;
  setTimezone: (t: string) => void;
  sx?: React.CSSProperties;
  placeholder?: string;
  isSelectionClearable?: boolean;
  size?: "small" | "medium";
}) => {
  const isMobile = useIsMobile();

  return (
    <Select
      variant="detachedOutlined"
      size={size}
      displayEmpty
      value={timezone}
      onChange={(e: SelectChangeEvent) => {
        const value = e.target.value as string;
        if (value === "clear") {
          setTimezone("");
        } else {
          setTimezone(value);
        }
      }}
      sx={{
        "& .MuiInputBase-input": {
          marginTop: "0px !important",
          color: timezone === "" ? "#8E9598" : "inherit",
        },
        width: isMobile ? "100%" : "340px",
        ...sx,
      }}
    >
      <MenuItem value="" disabled>
        {placeholder}
      </MenuItem>
      {Timezones.map((tz) => (
        <MenuItem key={tz} value={tz}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <span>{TimezoneAbbreviations[tz] || tz}</span>
          </Box>
        </MenuItem>
      ))}
      {isSelectionClearable && (
        <MenuItem key="clear" value="clear">
          Clear
        </MenuItem>
      )}
    </Select>
  );
};
